// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.champ-adresse-recherche {
  position: relative;
}

.champ-adresse-recherche input {
  padding-right: 4rem;
}

.champ-adresse-spinner {
  position: absolute;
  right: 1.2rem;
  top: 50%;
  width: 18px;
  height: 18px;
  margin-top: -9px;
  border: 2px solid #e5e7eb;
  border-top-color: #f97316;
  border-radius: 50%;
  animation: champ-adresse-rotation 0.8s linear infinite;
}

@keyframes champ-adresse-rotation {
  to { transform: rotate(360deg); }
}

.champ-adresse-liste {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 100;
  margin: 0;
  padding: 0;
  list-style: none;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-top: none;
  border-radius: 0 0 0.8rem 0.8rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-height: 250px;
  overflow-y: auto;
}

.champ-adresse-liste li {
  padding: 1rem 1.4rem;
  font-size: 1.3rem;
  color: #374151;
  cursor: pointer;
  border-bottom: 1px solid #f1f5f9;
}

.champ-adresse-liste li:last-child {
  border-bottom: none;
}

.champ-adresse-liste li:hover {
  background: #f8fafc;
}

.champ-adresse-alerte {
  margin: 0.6rem 0 0;
  font-size: 1.3rem;
  color: #f97316;
}

.champ-adresse-champs {
  display: flex;
  flex-wrap: wrap;
  gap: 0 2rem;
}

.champ-adresse-numero {
  flex: 0 0 12rem;
}

.champ-adresse-voie {
  flex: 1 1 24rem;
}

.champ-adresse-code-postal {
  flex: 0 0 16rem;
}

.champ-adresse-ville {
  flex: 1 1 20rem;
}

.champ-adresse input.input-error {
  border-color: #dc2626;
}
`, "",{"version":3,"sources":["webpack://./src/composants/ChampAdresse/ChampAdresse.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;EAChC,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".champ-adresse-recherche {\n  position: relative;\n}\n\n.champ-adresse-recherche input {\n  padding-right: 4rem;\n}\n\n.champ-adresse-spinner {\n  position: absolute;\n  right: 1.2rem;\n  top: 50%;\n  width: 18px;\n  height: 18px;\n  margin-top: -9px;\n  border: 2px solid #e5e7eb;\n  border-top-color: #f97316;\n  border-radius: 50%;\n  animation: champ-adresse-rotation 0.8s linear infinite;\n}\n\n@keyframes champ-adresse-rotation {\n  to { transform: rotate(360deg); }\n}\n\n.champ-adresse-liste {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 100;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-top: none;\n  border-radius: 0 0 0.8rem 0.8rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  max-height: 250px;\n  overflow-y: auto;\n}\n\n.champ-adresse-liste li {\n  padding: 1rem 1.4rem;\n  font-size: 1.3rem;\n  color: #374151;\n  cursor: pointer;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.champ-adresse-liste li:last-child {\n  border-bottom: none;\n}\n\n.champ-adresse-liste li:hover {\n  background: #f8fafc;\n}\n\n.champ-adresse-alerte {\n  margin: 0.6rem 0 0;\n  font-size: 1.3rem;\n  color: #f97316;\n}\n\n.champ-adresse-champs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0 2rem;\n}\n\n.champ-adresse-numero {\n  flex: 0 0 12rem;\n}\n\n.champ-adresse-voie {\n  flex: 1 1 24rem;\n}\n\n.champ-adresse-code-postal {\n  flex: 0 0 16rem;\n}\n\n.champ-adresse-ville {\n  flex: 1 1 20rem;\n}\n\n.champ-adresse input.input-error {\n  border-color: #dc2626;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
